<template>
    <div class="cart">
        <div class="icon-box">
            <div class="icon icon-facebook">
                <img src="@/assets/icon/facebook.png" alt="">
            </div>
            <div class="icon icon-google">
                <img src="@/assets/icon/google.png" alt="">
            </div>
            <div class="icon icon-telegram">
                <img src="@/assets/icon/telegram.png" alt="">
            </div>
            <div class="icon share">Share</div>
        </div>
        <div class="view-info" >View Restaurant Information</div>
        <div class="book-btn" >
            <img src="@/assets/icon/book_icon.png" alt="">
            Book a Table
        </div>
        <div class="cart-title">
            <i class="el-icon-shopping-bag-1"></i>
            <span>Your Cart</span>
        </div>
        <div class="main-cart">
            <div class="cart-content" >
                <ul>
                    <li v-for="food in cartList" :key="food.itemId">{{ food.itemName }}</li>
                </ul>
            </div>
            <div class="type-box">
                <div :class="['type-btn', { 'type-active': transType === 'delivery' }]" @click="changeTrans('delivery')">
                    <i class="iconfont icon-waimai"></i>
                    <span>Delivery</span>
                </div>
                <div :class="['type-btn', { 'type-active': transType === 'pickup' }]" @click="changeTrans('pickup')">
                    <i class="el-icon-s-goods"></i>
                    <span>Pick-up</span>
                </div>
            </div>
            <div class="time-btn">
                Select Time
                <i class="el-icon-arrow-right"></i>
            </div>
            <div class="coupon-box">
                <input type="text" placeholder="Coupon code">
                <span class="apply-btn" >Apply Coupon</span>
            </div>
        </div>
        <div class="order-btn" >
            <span style="flex:1" >Order Now</span>
            <span class="price-box" >£10.05</span>
        </div>
    </div>
</template>
<script>
import bus from '@/utils/bus';
export default {
    props: {
        cartList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            transType: 'delivery'
        }
    },
    mounted() {
        bus.$on('addCart', (item)=>{
            console.log('添加cart', item)
        })
    },
    methods: {
        changeTrans(type) {
            this.transType = type
        },
    }
}
</script>
<style lang="scss" scoped>
    .cart {
        .icon-box {
            height: 46px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: 10px;
            padding-bottom: 10px;

            .icon {
                height: 40px;
                width: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 20px;
                box-shadow: 0px 4px 4px rgba($color: #000000, $alpha: 0.2);
                cursor: pointer;
                img {
                    height: 30px;
                    widows: 30px;
                }
            }
            .icon-facebook {
                background-color: #1877F2;
                img {
                    height: 20px;
                    widows: 20px;
                }
            }
            .icon-google {
                background-color: #fff;
            }
            .icon-telegram {
                i {
                    color: #fff;
                    font-size: 34px;
                }
            }
            .share {
                font-size: 30px;
                font-weight: 700;
                color: #000;
                box-shadow: none;
                margin-left: 25px;
            }

        }
        .view-info, .book-btn {
            margin-top: 20px;
            height: 48px;
            border-radius: 24px;
            background-color: #09CA6A;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 20px;
            box-shadow: 0px 5px 8px #8F9698;
            transition: all ease-in-out .2s;
            cursor: pointer;
            &:hover {
                box-shadow: 0px 4px 6px #505454;
            }
        }
        .book-btn {
            background-color: #fff;
            color: #9A47EE;
            font-size: 20px;
            img {
                width: 32px;
                margin-right: 20px;
            }
        }
        .cart-title {
            height: 48px;
            padding: 0 20px;
            font-size: 18px;
            color: #000;
            display: flex;
            align-items: center;
            font-weight: 700;
            box-shadow: 0px 4px 4px rgba($color: #000000, $alpha: 0.2);
            background-color: #fff;
            margin-top: 20px;
            cursor: default;
            border-radius: 2px;
            i {
                margin-right: 10px;
                font-size: 22px;
            }
        }
        .main-cart {
            min-height: 350px;
            margin-top: 15px;
            background-color: #fff;
            border-radius: 4px;
            box-shadow: 0px 4px 4px rgba($color: #000000, $alpha: 0.2);
            padding: 0 20px 20px;
            display: flex;
            flex-direction: column;

            .cart-content {
                flex: 1;
                border-bottom: 1px solid black;
            }
            .type-box {
                height: 40px;
                display: flex;
                margin-top: 10px;

                .type-btn {
                    flex: 1;
                    width: 60px;
                    background-color: rgba($color: #000000, $alpha: 0.2);
                    border-radius: 4px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                    font-size: 17px;
                    font-weight: 600;
                    color: #000;
                    cursor: pointer;
                    transition: all ease-in-out .2s;
                    &:hover {
                        background-color: rgba($color: #000000, $alpha: 0.1);
                    }
                    &:nth-child(1) {
                        margin-right: 20px;
                    }
                    i {
                        color: #000;
                        margin-right: 10px;
                        font-size: 20px;
                    }
                }
                .type-active {
                    background-color: #09CA6A;
                    color: #fff;
                    i {
                        color: #fff;
                    }
                    &:hover {
                        background-color: #09CA6A;
                    }
                }
            }
            .time-btn {
                margin-top: 10px;
                height: 40px;
                display: flex;
                align-items: center;
                font-size: 16px;
                color: #000;
                font-weight: 600;
                justify-content: space-between;
                padding: 0 20px;
                background-color: #fff;
                border-radius: 4px;
                box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
                transition: all ease-in-out .2s;
                cursor: pointer;
                &:hover {
                    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
                }

                i {
                    margin-left: 20px;
                }
            }
            .coupon-box {
                margin-top: 10px;
                height: 40px;
                border-radius: 20px;
                background-color: #fff;
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                font-weight: 500;
                font-size: 16px;
                display: flex;
                align-items: center;

                input {
                    flex: 1;
                    height: 40px;
                    color: #000;
                    padding-left: 20px;
                    overflow: hidden;
                    border-radius: 20px;
                }
                .apply-btn {
                    height: 40px;
                    border-radius: 20px;
                    padding: 0 20px;
                    font-size: 16px;
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #09CA6A;
                    white-space: nowrap;
                    font-weight: 600;
                    color: #fff;
                    transition: all ease-in-out 0.2s;
                    cursor: pointer;
                    &:hover {
                        background-color: #07b75f;
                    }
                }
            }
        }
        .order-btn {
            margin-top: 10px;
            height: 50px;
            display: flex;
            align-items: center;
            background-color: #07b75f;
            color: #fff;
            font-size: 20px;
            font-weight: 800;
            border-radius: 25px;
            padding-left: 20px;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            cursor: pointer;
            transition: all ease-in-out .2s;
            &:hover {
                background-color: #09a054;
            }

            .price-box {
                height: 50px;
                border-radius: 25px;
                padding: 0 20px;
                min-width: 100px;
                background-color: #fff;
                color: #000;
                display: flex;
                align-items: center;
            }
        }
    }

</style>